import { Box, Backdrop, CircularProgress } from '@mui/material';
import { ReactNode } from 'react';

export interface CustomCircularLoadingProps {
  isLoading: boolean;
  height?: number | string;
  width?: number | string;
  children?: ReactNode;
  top?: number;
  position?: 'absolute' | 'relative';
  bgColor?: string;
}

export default function CustomCircularLoading({
  isLoading,
  height,
  width,
  children,
  top,
  position = 'absolute',
  bgColor = 'transparent',
}: CustomCircularLoadingProps) {
  return isLoading ? (
    <Box data-testid="customCircularLoading-render-test" height={height} width={width}>
      <Backdrop open sx={{ position, backgroundColor: bgColor, top }}>
        <CircularProgress />
      </Backdrop>
    </Box>
  ) : (
    children
  );
}
